import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-project-id"]
const _hoisted_2 = {
  key: 0,
  class: "projects-list__body-item-clients"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "projects-list__body-item-client-divider"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "projects-list__body-item-client-divider"
}
const _hoisted_7 = {
  key: 1,
  class: "projects-list__body-item-parameters"
}
const _hoisted_8 = { class: "projects-list__body-item-footer" }
const _hoisted_9 = { class: "projects-list__body-item-tags" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "projects-list__body-item-date" }

import { computed, ref } from "vue";
import { Project } from "@/store/search";
import { useRoute } from "vue-router";
import ProjectListItemParameter from "@/components/main/search-panel/ProjectListItemParameter.vue";

type ProjectItemProps = {
	project: Project
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectListItem',
  props: {
    project: {}
  },
  setup(__props: any) {

const route = useRoute()
const props = __props

const isExpanded = ref(false)

const isOpened = computed(() =>
	route.query.page === 'project' && Number(route.query.id) === props.project.Id
)

function formatDate(date?: string | Date) {
	if (!date) return "";

	const dateObj = typeof date === "string" ? new Date(date) : date;
	return dateObj.toLocaleDateString("ru-RU", {
		day: "2-digit",
		month: "2-digit",
		year: "2-digit",
	});
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["projects-list__body-item", { 'projects-list__body-item--opened': isOpened.value }]),
    "data-project-id": props.project.Id
  }, [
    _createElementVNode("div", {
      class: "projects-list__body-item-colored",
      style: _normalizeStyle({ backgroundColor: props.project.Color })
    }, null, 4),
    _createVNode(_component_router_link, {
      to: { query: { page: 'project', id: props.project.Id } },
      class: "projects-list__body-item-name",
      innerHTML: props.project.Name
    }, null, 8, ["to", "innerHTML"]),
    (props.project.Clients?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.project.Clients.slice(0, 2), (c, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: c.Id
            }, [
              _createVNode(_component_router_link, {
                to: { query: { page: 'client', id: c.Id } },
                class: "projects-list__body-item-client"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: c.Name
                  }, null, 8, _hoisted_3)
                ]),
                _: 2
              }, 1032, ["to"]),
              (index === 0 ? props.project.Clients.length > 1 : isExpanded.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " / "))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (!isExpanded.value && props.project.Clients.length > 2)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "projects-list__body-item-client-show-more",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpanded.value = true))
              }, _toDisplayString(_ctx.$t('more_count_label', { count: props.project.Clients.length - 2 })), 1))
            : _createCommentVNode("", true),
          (isExpanded.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.project.Clients.slice(2), (c, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: c.Id
                }, [
                  _createVNode(_component_router_link, {
                    to: { query: { page: 'client', id: c.Id } },
                    class: "projects-list__body-item-client"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: c.Name
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (index + 1 < props.project.Clients.slice(2).length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " / "))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (props.project.Parameters?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.project.Parameters, (param, index) => {
            return (_openBlock(), _createBlock(ProjectListItemParameter, {
              key: index,
              parameter: param
            }, null, 8, ["parameter"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.project.Tags, (tg) => {
          return (_openBlock(), _createElementBlock("span", {
            key: tg.Id,
            class: "projects-list__body-item-tag",
            innerHTML: `#${tg.Name.toLowerCase()}`
          }, null, 8, _hoisted_10))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(formatDate(props.project.CreateTime)), 1)
    ])
  ], 10, _hoisted_1))
}
}

})